export const empty = {
  object: {},
  array: [],
}
